"use client";

import { Button } from "@workspace/ui/components/button";
import { useEffect } from "react";

export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		// Log error to console in development
		if (process.env.NODE_ENV === "development") {
			console.error("Global error:", error);
		}
		// Sentry automatically captures errors in production
	}, [error]);

	return (
		<html lang="en">
			<body>
				<div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-4 py-16 text-foreground">
					<div className="flex flex-col items-center gap-2 text-center">
						<h1 className="text-4xl font-bold tracking-tight">
							Unexpected Error
						</h1>
						<p className="text-muted-foreground max-w-md text-lg">
							Something went wrong with the application. This is usually
							temporary.
						</p>
					</div>

					<div className="flex gap-3">
						<Button onClick={() => reset()} variant="default" size="lg">
							Try again
						</Button>
						<Button
							onClick={() => (window.location.href = "/")}
							variant="outline"
							size="lg"
						>
							Go home
						</Button>
					</div>

					{process.env.NODE_ENV === "development" && error.message && (
						<div className="mt-8 w-full max-w-2xl rounded-lg border border-red-500/20 bg-red-500/10 p-4">
							<p className="mb-2 font-mono text-sm font-semibold text-red-500">
								Development Error:
							</p>
							<p className="font-mono text-xs text-red-400">
								{error.message}
							</p>
							{error.digest && (
								<p className="mt-2 font-mono text-xs text-red-400">
									Digest: {error.digest}
								</p>
							)}
							{error.stack && (
								<details className="mt-4">
									<summary className="cursor-pointer font-mono text-xs text-red-400">
										Stack trace
									</summary>
									<pre className="mt-2 overflow-auto font-mono text-xs text-red-400">
										{error.stack}
									</pre>
								</details>
							)}
						</div>
					)}
				</div>
			</body>
		</html>
	);
}
